export class SubscriberService {
  constructor(context) {
    this.context = context;
    this.axios = this.context.$axios;
  }

  //Clients
  async GetClients({ limit = 10, page, searchTerm = "" }) {
    try {
      const clients = await this.axios.get(
        `${
          process.env.VUE_APP_API_BASE_URL
        }/subscribers?limit=${limit}&page=${page}&searchTerm=${searchTerm}&businessUnitId=${localStorage.getItem(
          "businessUnitId"
        )}`
      );

      return clients.data;
    } catch (err) {
      if (err.toString().includes("401")) {
        localStorage.removeItem("user-token");
        localStorage.removeItem("token-expiration");
        this.context.$router.push({ path: "/" });
      }
      console.log(`fallo la peticion: ${err}`);
    }
  }

  //Products
  async getProducts({ businessUnitId, subscriberId }) {
    try {
      let products = (
        await this.axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/subscribers/${subscriberId}/products?businessUnitId=${businessUnitId}`
        )
      ).data;
      
      const index = products.findIndex(prod => prod.ProductId === 53);
      if (products[index]) {
        products[index].BookCode = products[index].BookCode.replace(/ /g, "");
      }
      return products;
    } catch (err) {
      console.log(err);
    }
  }

  //Banners
  async getBanners({ productId, businessUnitId, subscriberId }) {
    try {
      const subscriberBanners = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/subscribers/${subscriberId}/banners?productId=${productId}&businessUnitId=${businessUnitId}`
      );
      return subscriberBanners.data;
    } catch (err) {
      console.log(err);
    }
  }

  //Listing
  async getSubscriberListing(bookCode, subscriberId, businessUnitId, isMobile) {
    try {
      const subscriberListing = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/subscribers/${subscriberId}/listings?isMobile=${isMobile}&businessUnitId=${businessUnitId}&bookCode=${bookCode}`
      );

      return subscriberListing.data;
    } catch (err) {
      console.log(err);
    }
  }

  // Subcriber
  async getSubcriber(subcriberId) {
    try {
      const subcriber = await this.axios.get(
        `${
          process.env.VUE_APP_API_BASE_URL
        }/subscribers/${subcriberId}?businessUnitId=${localStorage.getItem(
          "businessUnitId"
        )}`
      );
      return subcriber.data;
    } catch (err) {
      console.log(err);
    }
  }
}
